import _ from 'underscore';
export default (url, slideIndex) => {
    const slide = (slideIndex + 1);
    let urlSplit = url.split('/');
    urlSplit = _.compact(urlSplit);
    let isNan = Number(urlSplit[urlSplit.length - 1]);
    isNan = _.isNaN(isNan);
    if (isNan) {
        urlSplit.push(slide);
        return urlSplit.join('/');
    }
    urlSplit[urlSplit.length - 1] = slide;
    return urlSplit.join('/');
};
